import Menu from 'Models/Menu';

export default [
  // Menu.assetInformation,
  Menu.assetMaterialEdit,
  Menu.assetMaterialDelete,
  // Menu.assetAlert,
  // Menu.searchAsset,
  Menu.assetsHelp,
];
